<div [formGroup]="control" class="{{hasErrors ? 'error' : ''}}">
  <div class="wb-select-wrapper">
    <select [formControlName]="config.property" name="{{config.property}}" id="{{config.property}}" (change)="selectionChanged($event)">
      @for (values of config.values; track values) {
        <option value="{{values.value}}">
          {{(values.numberValue ? values.numberValue + ' ' : '')}}{{values.label | labelKeyMore:values.value | translate | ucFirst | unicorn:values.value}}
          @if (values.calculatedCosts) {
            (+{{values.calculatedCosts /
            100 | currency:this._state.currency:'symbol':'1.2-2'}})
          }
        </option>
      }
    </select>
  </div>
  <app-field-error [config]="config" (validityChanged)="validityChanged($event)"></app-field-error>
</div>
